import React from 'react';
import PdfViewer from 'components/PdfViewer';

import './privacy.styl';

export default () => <PdfViewer url={window.file} className="privacy"/>;
